import { render } from "./VehicleCategories.vue?vue&type=template&id=67ebcb0e&scoped=true"
import script from "./VehicleCategories.vue?vue&type=script&lang=js"
export * from "./VehicleCategories.vue?vue&type=script&lang=js"

import "./VehicleCategories.vue?vue&type=style&index=0&id=67ebcb0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ebcb0e"]])

export default __exports__